<template>
  <div class="min-h-screen bg-base-100">
    <div class="container mx-auto px-4 py-12">
      <div class="max-w-4xl mx-auto">
        <h1 class="text-4xl font-bold text-base-content mb-8">
          Política de Privacidad y Protección de Datos
        </h1>

        <div class="prose prose-lg max-w-none">
          <p class="text-lg text-base-content/80 mb-8">
            La presente Política de Privacidad forma parte integrante del Aviso
            Legal del sitio web.
          </p>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              RECOGIDA Y USO DE DATOS
            </h2>
            <p class="text-base-content/80 mb-4">
              En cumplimiento con lo dispuesto en la normativa vigente en
              materia de protección de datos, DESERTANDO CLUB DE AVENTURAS, S.L.
              (en adelante DESERTANDO), le informa que los datos personales del
              usuario, obtenidos o recabados a través del sitio web, serán
              tratados por DESERTANDO para el cumplimiento, entre otras, de las
              siguientes finalidades:
            </p>
            <ul class="list-disc pl-6 text-base-content/80 mb-4">
              <li>
                Posibilitar la prestación de los servicios ofrecidos en el sitio
                web.
              </li>
              <li>Gestionar el registro de los usuarios.</li>
              <li>
                Atender solicitudes de consulta, información y/o
                quejas/reclamaciones del usuario.
              </li>
              <li>
                Informar a los usuarios sobre novedades y otras cuestiones de
                interés.
              </li>
            </ul>
            <p class="text-base-content/80 mb-4">
              Siempre que se solicite, y el usuario facilite una dirección de
              correo electrónico, teléfono móvil u otro medio de comunicación
              electrónica, el usuario expresamente acepta y autoriza que dichos
              medios sean utilizados preferentemente como canal de comunicación
              para cumplir todas o alguna de las finalidades anteriormente
              informadas, así como canal a través del cual poderle informar de
              cualesquiera otros cambios relevantes que se produzcan en el sitio
              web.
            </p>
            <p class="text-base-content/80">
              Los Usuarios garantizan que sus datos personales aportados son
              verdaderos, exactos, completos y actualizados, ya que los usuarios
              serán los únicos responsables de cualquier daño o perjuicio,
              directo o indirecto, que pudiera ocasionarse como consecuencia del
              incumplimiento de tal obligación.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              COOKIES
            </h2>
            <p class="text-base-content/80 mb-4">
              DESERTANDO hace uso de cookies propias y de terceros (de tipo
              técnico y de personalización) que identifican a los usuarios
              unívocamente durante una sesión para poder mostrarles información
              privada y/o personalizada y les permiten navegar por todas las
              áreas o secciones del sitio web y hacer uso de todas sus
              funcionalidades. Estas cookies son necesarias para el
              funcionamiento del sitio web.
            </p>
            <p class="text-base-content/80 mb-4">
              DESERTANDO también utiliza <strong>cookies analíticas</strong> de
              terceros que le permiten medir la audiencia y parámetros del
              tráfico, controlar el progreso y número de entradas, así como las
              operaciones más relevantes de los Usuarios en el Portal. Las
              cookies son ficheros enviados al navegador, mediante un servidor
              web, con la finalidad de registrar las actividades de los usuarios
              durante su tiempo de navegación.
            </p>
            <p class="text-base-content/80">
              El usuario puede rechazar la instalación de cookies, mediante la
              activación de los controles oportunos en su navegador con la
              opción que rechace la aceptación de cookies. El usuario debe tener
              en cuenta que, si selecciona esta opción, es posible que no pueda
              acceder a determinadas áreas o secciones del sitio web.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              CONTACTO Y DERECHOS DEL USUARIO
            </h2>
            <p class="text-base-content/80 mb-4">
              El usuario tiene reconocidos los derechos de acceso,
              rectificación, cancelación y oposición, los cuales podrá ejercitar
              dirigiendo una comunicación postal y fotocopia del DNI con el
              asunto "Ref. Privacidad de datos" a la dirección: Desertando Club
              de Aventuras, S.L. C/ Arturo Soria, 333, 28033 Madrid.
            </p>
            <p class="text-base-content/80 mb-4">
              También puede contactar por correo electrónico a:
              <a
                href="mailto:info@soleando.eu"
                class="text-primary hover:underline"
                >info@soleando.eu</a
              >
            </p>
            <p class="text-base-content/80">
              También tendrá el derecho a presentar una reclamación ante la
              Agencia Española de Protección de datos (APD), especialmente
              cuando no haya obtenido satisfacción en el ejercicio de sus
              derechos.
            </p>
            <div class="bg-base-200 p-4 rounded-lg mt-4">
              <p class="text-base-content/80">
                <strong>Agencia Española de Protección de Datos:</strong><br />
                C/ Jorge Juan, 6. 28001 – Madrid<br />
                Telf. 901100099 / 912663517
              </p>
            </div>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              RESPONSABLE DEL TRATAMIENTO
            </h2>
            <div class="bg-base-200 p-6 rounded-lg">
              <p class="text-base-content/80 mb-2">
                <strong>DESERTANDO CLUB DE AVENTURAS, S.L.</strong>
              </p>
              <p class="text-base-content/80 mb-2">
                Domicilio social: C/ Arturo Soria, 333 – 28033 Madrid
              </p>
              <p class="text-base-content/80 mb-2">CIF: B87565966</p>
              <p class="text-base-content/80 mb-2">
                Teléfono: (+34) 608 76 29 62 / (+34) 620 50 17 61
              </p>
              <p class="text-base-content/80">
                Correo electrónico:
                <a
                  href="mailto:info@soleando.eu"
                  class="text-primary hover:underline"
                  >info@soleando.eu</a
                >
              </p>
            </div>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              LEGISLACIÓN APLICABLE
            </h2>
            <p class="text-base-content/80">
              Las presentes Condiciones se regirán en todo momento por lo
              dispuesto en la legislación española y europea en materia de
              protección de datos de carácter personal y de privacidad,
              reflejada en la Ley Orgánica 3/2018, de 5 de diciembre, de
              Protección de Datos Personales y de Garantía de Derechos Digitales
              (LOPD GDD) y el Reglamento (UE) 2016/679 del Parlamento Europeo y
              del Consejo de 27 de abril de 2016 relativo a la protección de las
              personas físicas (RGPD).
            </p>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: "default",
});

useSeoMeta({
  title: "Política de Privacidad y Protección de Datos - Soleando",
  description:
    "Política de privacidad y protección de datos de Soleando. Información sobre el tratamiento de datos personales.",
});
</script>

<style scoped></style>
